import React from 'react';
import StorageBrazeCard from 'src/cms-components/StorageBrazeCard/StorageBrazeCard';
import { CMS_THEME } from 'src/common/enums';
import { useBrazeContext } from 'src/hooks/useBraze/useBraze';
import { formatBazaarVoiceId, formatSku } from 'src/utils/helpers';
import CardList from '../card_list/CardList';
import ProductCard from '../product_card/ProductCard';

const ProductList = (props: {
  productsList: ProductCard[];
  theme?: CMS_THEME;
  onClick?: (title: string) => void;
}) => {
  const { theme = CMS_THEME.LIGHT, onClick, productsList } = props;
  const { brazeCardSlots, brazeCardPayloads, loaded } = useBrazeContext();

  const renderProductCards = productsList.map((product, i) => {
    const image = product.relationships.image.gatsbyImage;
    image.height = 186;
    image.width = 186;
    const { title } = product;
    const link = product.path.alias;
    const linkDirect = product.field_alternate_url;
    const bvID = formatBazaarVoiceId(product?.field_bazaarvoice_id);
    const psId = formatSku(product?.field_pricespider_id ?? '');

    return (
      <ProductCard
        drupalId={product.drupal_id}
        cmsTheme={theme}
        key={`${product.id}-${i}`}
        image={image}
        title={title}
        link={link}
        linkDirect={linkDirect}
        psID={psId}
        bvID={bvID}
        type="products"
        onClick={() => onClick?.(title)}
      />
    );
  });

  return (
    <CardList
      customList={
        loaded
          ? [
              ...renderProductCards,
              brazeCardSlots.length > 0 && (
                <StorageBrazeCard
                  defaultCard={brazeCardSlots[0]}
                  brazeCard={brazeCardPayloads[0]}
                />
              ),
            ]
          : renderProductCards
      }
    />
  );
};

export default ProductList;
